export default __webpack_public_path__ + "static/media/prize-5-cn.52510bcb.webp";